<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="lock-icon"
    width="13.271"
    height="17.786"
    viewBox="0 0 13.271 17.786"
  >
    <g transform="translate(-7937.5 -3446.5)">
      <path
        class="a"
        :fill="iconColor"
        :stroke="iconColor"
        d="M-73.4,87.312V89h-1.661v-1.7a4.877,4.877,0,0,1,4.977-4.771h.144a4.877,4.877,0,0,1,4.977,4.771V89h-1.657V87.312a3.255,3.255,0,0,0-3.318-3.181h-.144A3.255,3.255,0,0,0-73.4,87.312Z"
        transform="translate(8014.063 3364.463)"
      />
      <path
        class="a"
        :fill="iconColor"
        :stroke="iconColor"
        d="M272.715,402.274h-9.668a1.3,1.3,0,0,0-1.3,1.3v7.73a1.3,1.3,0,0,0,1.3,1.3h9.668a1.3,1.3,0,0,0,1.3-1.3v-7.73A1.3,1.3,0,0,0,272.715,402.274Zm-3.74,5.013a1.388,1.388,0,0,1-.241.241v1.483a.853.853,0,0,1-1.706,0v-1.483a1.387,1.387,0,1,1,1.947-.241Z"
        transform="translate(7676.254 3051.179)"
      />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'
  export default {
    name: 'Lock',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#ef5350' : '#d32f2f'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 13.271px;
    height: 17.786px;
  }
</style>
